<template>
  <div class="component-wrap" :class="{ overflow: exercise.code !== 'KY' }">
    <component
      ref="quizze"
      :key="exercise.code"
      :is="quizzes[exercise.code]"
      @changeOption="changOption"
      :exercise="exercise"
      :userAnswer="userAnswer"
      action="/api/auth/audioRecognition"
      :is-show-explain="isShowExplain"
      :is-done="isDone"
      :is-random="isRandomOption"
      :mode="exercise.mode"
      :is-directly-complete="false"
      :is-exam="isExam"
      :extras="exercise.extras"
      :iat-url="iatUrl"
      :can-drag="canDrag"
      :play-times="exercise.playTimes || playTimes"
      @switch="isShowExplain = !isShowExplain"
      @error="audioError"
      @played="played"
      @complete="complete"
      @last="handlerLast"
      @ended="onVideoEnded"
      @change="change">
    </component>
  </div>
</template>

<script>
import 'vanthink-components/icon/iconfont.css';
import TYLJ from 'vanthink-components/components/quiz/TYLJ.vue';
import JXZH from 'vanthink-components/components/quiz/JXZH.vue';
import KY from 'vanthink-components/components/quiz/KY.vue';
import DX from 'vanthink-components/components/quiz/DX.vue';
import QHLJ from 'vanthink-components/components/quiz/QHLJ.vue';
import MED from 'vanthink-components/components/quiz/MED.vue';
import BQWZ from 'vanthink-components/components/quiz/BQWZ.vue';
import WK from 'vanthink-components/components/quiz/WK.vue';
import CHXZ from 'vanthink-components/components/quiz/CHXZ.vue';
import DCTX from 'vanthink-components/components/quiz/DCTX.vue';
import SK from 'vanthink-components/components/quiz/SK.vue';
import HYDC from 'vanthink-components/components/quiz/HYDC.vue';
import DCPX from 'vanthink-components/components/quiz/DCPX.vue';
import YDLJ from 'vanthink-components/components/quiz/YDLJ.vue';
import THXZ from 'vanthink-components/components/quiz/THXZ.vue';
import XCTK from 'vanthink-components/components/quiz/XCTK.vue';
import WXTK from 'vanthink-components/components/quiz/WXTK.vue';
import utils from '@/services/utils';
import api from '@/api/graphql/englishCourse';

export default {
  props: {
    exercises: {
      type: Array,
      required: true,
    },
    userAnswer: {
      type: [Array, String, Object, Number],
      default: null,
    },
    isBacktrack: {
      type: Number,
      default: 0,
    },
    isExam: {
      type: Boolean,
      default: false,
    },
    playTimes: {
      type: Number,
      default: 1,
    },
    status: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      newExercises: [],
      wrongExercises: [],
      results: [],
      exerciseIndex: 0,
      isShowExplain: true,
      iatUrl: '', // 科大讯飞语音识别加密后地址
      isDone: false,
      autoNext: true,
      canDrag: 0,
      isRight: 0,
      quizzes: {
        QHLJ,
        KY,
        DX,
        TYLJ,
        JXZH,
        MED,
        BQWZ,
        WK,
        CHXZ,
        DCTX,
        SK,
        HYDC,
        DCPX,
        YDLJ,
        THXZ,
        XCTK,
        WXTK,
      },
      isPlayed: false,
    };
  },
  watch: {
    exercise: {
      handler() {
        // 游戏需要音频播放完进入下一题,不需要的游戏默认为true
        if (this.exercise.code !== 'CHXZ' && this.exercise.code !== 'DCPX') {
          this.isPlayed = true;
        } else {
          this.isPlayed = false;
        }
        if (this.exercise
          && (this.exercise.code === 'MRD' || this.exercise.code === 'WK' || this.exercise.code === 'SK' || (this.exercise.code === 'CHXZ' && !this.isExam))) {
          this.isRight = 1;
          this.isDone = true;
        } else {
          this.isRight = 0;
          this.isDone = false;
        }
        if (this.exercise && this.exercise.code === 'KY') {
          this.getIatUrl();
        }
      },
      deep: true,
      immediate: true,
    },
    exercises: {
      handler() {
        if (this.isExam) {
          this.initNewExercises();
        }
      },
      deep: true,
    },
    newExercises() {
      if (this.newExercises.length === 0) {
        this.$emit('finish', {
          results: this.results,
        });
      } else {
        this.$emit('exerciseChange', {
          ...this.exercise,
        });
      }
    },
    exerciseIndex() {
      this.$emit('exerciseChange', {
        id: this.exercise.id,
        exerciseIndex: this.exerciseIndex,
      });
    },
  },
  computed: {
    exercise() {
      return this.newExercises[this.exerciseIndex] || {};
    },
    isDirectlyDone() {
      return this.exercise.code === 'MED'
        || this.exercise.code === 'WK'
        || this.exercise.code === 'SK';
    },
    isRandomOption() {
      return (this.exercise.code === 'CHXZ' || this.exercise.code === 'DX') && !this.isExam;
    },
  },
  created() {
    this.initNewExercises();
  },
  mounted() {
    if (this.exercise.videoDone) {
      this.canDrag = 1;
    }
  },
  methods: {
    onVideoEnded() {
      this.canDrag = 1;
      utils.post('/api/home/assessment/basic/saveVideoPlay', {
        data: {
          url: this.exercise.video,
        },
      })
        .then();
    },
    complete() {
      if (this.isExam) return;
      if ((this.exercise.code === 'DCTX'
        || this.exercise.code === 'HYDC'
        || (this.exercise.code === 'SK' && this.exercise.mode === 2)) && this.isRight) {
        this.autoNext = false;
        clearTimeout(this.delay);
        this.isDone = true;
        this.delay = setTimeout(() => {
          this.autoNext = true;
          this.next();
        }, 1000);
      } else {
        this.next();
      }
    },
    initNewExercises() {
      this.newExercises = utils.clone(this.exercises);
    },
    audioError({ message }) {
      utils.error(message);
    },
    played() {
      this.isPlayed = true;
      if (((this.exercise.code === 'CHXZ' && this.exercise.mode === 2)
        || this.exercise.code === 'DCPX') && this.isRight) {
        this.autoNext = false;
        clearTimeout(this.delay);
        this.delay = setTimeout(() => {
          this.autoNext = true;
          this.next();
        }, 200);
      }
    },
    speak() {
      if (this.$refs.quizze.getFocus) {
        this.$refs.quizze.getFocus();
      }
    },
    change(payload) {
      this.$nextTick(() => {
        this.isRight = payload.isRight;
        const exercise = {
          ...this.exercise,
          ...payload,
          isRight: payload.isRight,
          userAnswer: payload.answer,
          isComplete: payload.isComplete,
        };
        this.$emit('change', exercise);
        if (!this.isExam && this.autoNext) {
          this.handlerAutoNext();
        }
      });
    },
    changOption(payload) {
      this.exercise.formatOptions = payload.formatOptions;
    },
    correctExercise() {
      /* eslint-disable no-lonely-if */
      this.pushResults();
      if (this.isRight) {
        this.removeNewExercise();
      } else {
        this.backwardsInsertExercise();
        this.wrongExercises.push(this.exercise);
      }
    },
    // 错题重练 向后插入
    backwardsInsertExercise() {
      if (this.newExercises.length <= 1) {
        const last = Object.assign({}, this.newExercises[0]);
        this.newExercises = [last];
        return;
      }

      const [first, ...others] = this.newExercises;
      if (this.newExercises.length > 2) {
        this.newExercises = others;
        this.newExercises.splice(2, 0, first);
      } else {
        this.newExercises = [...others, first];
      }
    },
    removeNewExercise() {
      if (this.newExercises.length === 1) {
        this.newExercises = [];
      } else {
        const [, ...others] = this.newExercises;
        this.newExercises = [...others];
      }
    },
    pushResults() {
      let answer;
      if (this.exercise.userAnswer) {
        answer = this.exercise.userAnswer;
      } else {
        if (this.exercise.code === 'DX') {
          answer = -1;
        } else {
          answer = [];
        }
      }
      this.results.push({
        id: this.exercise.id,
        code: this.exercise.code,
        isRight: this.exercise.isRight || false,
        answer,
      });
    },
    handlerAutoNext() {
      // if ((this.exercise.code === 'QHLJ' || this.exercise.code === 'DCTX') && this.isRight) {
      //   this.autoNext = false;
      //   clearTimeout(this.delay);
      //   this.isDone = true;
      //   this.delay = setTimeout(() => {
      //     this.autoNext = true;
      //     this.next();
      //   }, 1000);
      // }

      if (this.exercise.code === 'CHXZ' && this.exercise.mode !== 2 && this.isRight) {
        this.autoNext = false;
        clearTimeout(this.delay);
        this.delay = setTimeout(() => {
          this.autoNext = true;
          this.next();
        }, 1000);
      }
    },
    handlerLast() {
      if (!this.isExam) return;
      if (this.exerciseIndex >= this.newExercises.length - 1) {
        utils.message('已经是最后一题了', 'warning');
      } else {
        this.exerciseIndex += 1;
      }
    },
    prev() {
      if (this.exerciseIndex <= 0) {
        utils.message('已经是第一题了', 'warning');
        return;
      }
      this.exerciseIndex -= 1;
    },
    next(type) {
      if (this.isExam) {
        if (this.exerciseIndex >= this.newExercises.length - 1) {
          utils.message('已经是最后一题了', 'warning');
        } else if (type !== 'text' || this.exercise.code !== 'QHLJ') {
          this.exerciseIndex += 1;
        }
      } else {
        if (this.delay) {
          clearTimeout(this.delay);
          if (!this.autoNext) {
            this.autoNext = true;
          }
        }
        if (this.isDirectlyDone) {
          this.isDone = true;
        }
        if (this.isDone) {
          if (this.isPlayed) {
            this.correctExercise();
            this.isDone = false;
            this.$emit('result', {
              results: this.results,
            });
          }
        } else {
          this.isDone = true;
        }
      }
    },
    clear() {
      this.$refs.quizze.clear();
    },
    getIatUrl() {
      api.getIatUrl().then(({ iatUrl }) => {
        this.iatUrl = decodeURIComponent(iatUrl);
      });
    },
  },
};
</script>
<style lang="scss" scoped>
  .component-wrap {
    height: 100%;
    &.overflow {
      overflow-y: auto;
    }
  }
</style>
